// Store/Analytics/ActionTypes.js - Basic version

// ====== INITIALIZATION ======
export const ANALYTICS_INIT_REQUEST = 'ANALYTICS_INIT_REQUEST';
export const ANALYTICS_INIT_SUCCESS = 'ANALYTICS_INIT_SUCCESS';
export const ANALYTICS_INIT_FAILURE = 'ANALYTICS_INIT_FAILURE';

// ====== PAGE TRACKING ======
export const TRACK_PAGE_REQUEST = 'TRACK_PAGE_REQUEST';
export const TRACK_PAGE_SUCCESS = 'TRACK_PAGE_SUCCESS';
export const TRACK_PAGE_FAILURE = 'TRACK_PAGE_FAILURE';

// ====== TIME TRACKING ======
export const UPDATE_TIME_REQUEST = 'UPDATE_TIME_REQUEST';
export const UPDATE_TIME_SUCCESS = 'UPDATE_TIME_SUCCESS';
export const UPDATE_TIME_FAILURE = 'UPDATE_TIME_FAILURE';

// ====== SESSION MANAGEMENT ======
export const SET_SESSION_DATA = 'SET_SESSION_DATA';
export const SET_FINGERPRINT = 'SET_FINGERPRINT';
export const SET_CURRENT_HIT_ID = 'SET_CURRENT_HIT_ID';
export const CLEAR_SESSION = 'CLEAR_SESSION';

// ====== CAMPAIGN TRACKING ======
export const SET_CAMPAIGN_DATA = 'SET_CAMPAIGN_DATA';
export const CLEAR_CAMPAIGN_DATA = 'CLEAR_CAMPAIGN_DATA';

// ====== TOKEN MANAGEMENT ======
export const SYNC_TOKEN = 'SYNC_TOKEN';
export const TOKEN_CHANGE = 'TOKEN_CHANGE';

// ====== PAGE STATE ======
export const SET_PAGE_START_TIME = 'SET_PAGE_START_TIME';
export const CLEAR_PAGE_START_TIME = 'CLEAR_PAGE_START_TIME';

// ====== ERROR HANDLING ======
export const CLEAR_ERROR = 'CLEAR_ERROR';
export const SET_ERROR = 'SET_ERROR';

// ====== BULK OPERATIONS ======
export const BULK_TRACK_REQUEST = 'BULK_TRACK_REQUEST';
export const BULK_TRACK_SUCCESS = 'BULK_TRACK_SUCCESS';
export const BULK_TRACK_FAILURE = 'BULK_TRACK_FAILURE';

// ====== CUSTOM EVENTS ======
export const TRACK_CUSTOM_EVENT = 'TRACK_CUSTOM_EVENT';
export const TRACK_USER_ACTION = 'TRACK_USER_ACTION';
export const TRACK_ERROR = 'TRACK_ERROR';

// ====== CONFIGURATION ======
export const SET_CONFIG = 'SET_CONFIG';
export const UPDATE_CONFIG = 'UPDATE_CONFIG';